<template>
  <div>
    <el-dialog
      title="请选择部门"
      :visible.sync="deptChoiceVisible"
      :width="selectDialogWidth"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="true"
    >
      <el-divider
        v-if="administrativeDepartmentCount !== 0"
        content-position="left"
        >用户行政机构</el-divider
      >
      <el-row
        v-if="userDept.isMajor === '1'"
        v-for="(userDept, index) of userDepartmentRole"
        :key="index"
      >
        <el-col :offset="3" :span="24" class="col-wapper">
          <el-radio v-model="deptRadio" :label="index"
            >{{ userDept.name }}({{ userDept.roleName }})</el-radio
          >
        </el-col>
      </el-row>

      <el-divider
        v-if="userDepartmentRole.length - administrativeDepartmentCount !== 0"
        content-position="left"
        >其他机构</el-divider
      >
      <el-row
        v-if="userDept.isMajor !== '1'"
        v-for="(userDept, index) of userDepartmentRole"
        :key="index"
      >
        <el-col :offset="3" :span="24" class="col-wapper">
          <el-radio v-model="deptRadio" :label="index"
            >{{ userDept.name }}({{ userDept.roleName }})</el-radio
          >
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <common-button
          size="default"
          type="primary"
          image
          @click="intoDept(userDepartmentRole[deptRadio])"
          >确定进入</common-button
        >
        <common-button
          v-if="$route.query.reelect"
          size="default"
          type="cancel"
          image
          @click="hanleCancel"
        >
          取消
        </common-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";

export default {
  name: "UserDept",
  data() {
    return {
      deptChoiceVisible: false,
      //选中的第几个部门
      deptRadio: 0,
      userDepartmentRole: [],
      //行政机构的个数
      administrativeDepartmentCount: 0,
      reelect: false
    };
  },
  mounted() {
    // this.$store.dispatch("queryCodeDict")
    this.reelect = this.$route.query.reelect;
    this.showChoice();
  },

  computed: {
    selectDialogWidth() {
      let departments = this.userDepartmentRole;
      let result = 30;
      for (let dept of departments) {
        let str = dept.name + dept.roleName;
        if (str.length <= 20) {
          result < 30 ? (result = 30) : result;
        } else if (str.length > 20 && str.length <= 25) {
          result < 35 ? (result = 35) : result;
        } else if (str.length > 25 && str.length <= 32) {
          result < 40 ? (result = 40) : result;
        } else if (str.length > 32) {
          result < 50 ? (result = 50) : result;
        }
      }
      return result + "%";
    }
  },
  methods: {
    //进入指定部门
    intoDept(userDeptRole) {
      //清除机构存在的信息
      this.$store.dispatch("clearDeptListData");
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          departmentId: userDeptRole.departmentId,
          isMajor: userDeptRole.isMajor
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/user/choiceIdentity", obj)
        .then(value => {
          if (value.data.code === "00000") {
            //设置当前用户的身份
            this.$store.dispatch("setCurrUserDeptIdCache", userDeptRole.id);
            //跳转到下一个页面
            this.$router.replace("/home");
          }
        });
      this.deptChoiceVisible = false;
    },
    //取消切换角色
    hanleCancel() {
      this.$router.replace("/home");
    },

    //打开选择窗口
    showChoice() {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          reelect: this.reelect === "true"
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/user/userIdentity", obj)
        .then(value => {
          if (value.data.code === "00000") {
            //用户已经选择过部门的信息,直接进入下一个页面
            if (value.data.data.selected && this.reelect !== "true") {
              //跳转到下一个页面
              this.$router.replace("/home");
            } else {
              this.userDepartmentRole = value.data.data.userDepartmentRole;
              for (let userDeptRole of this.userDepartmentRole) {
                if (userDeptRole.isMajor === "1") {
                  this.administrativeDepartmentCount++;
                }
              }

              if (this.userDepartmentRole.length > 1) {
                //如果用户存在多个部门身份 显示选择窗口让其选择部门
                this.deptChoiceVisible = true;
              } else if (this.userDepartmentRole.length === 1) {
                //否则直接进入第一个部门
                this.intoDept(this.userDepartmentRole[0]);
              } else {
                //清除机构存在的信息
                this.$store.dispatch("clearDeptListData");
                //跳转到下一个页面
                this.$router.replace("/home");
              }
            }
            this.$store.dispatch("setUserAllDept", this.userDepartmentRole);
          }
        });
    }
  }
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/pages/deptSelect/DeptSelect.vue